import { createFileRoute } from '@tanstack/react-router'
import { CustomJobsListPage } from '@/features/custom-jobs/list-page'

export const Route = createFileRoute('/_authenticated/company-jobs/custom-job/')({
  component: CustomJobsListPage,
})
